/**
 * Exact text-width measurement, for the prompt-box geometry model
 * (`prompt-ui.geometry.js`) and the game-start screen's label widths
 * (`game-start/game-start-layout.js`).
 *
 * Replaces the previous `chars × fontSize × multiplier` heuristic, which
 * mispredicted by tens of pixels across viewports (sign-flipping in some
 * states). Uses canvas measureText — sync, sub-millisecond, browser-native.
 *
 * No cache: ~3 calls per `computeLayout`, savings would be invisible.
 */

const FONT_FAMILY = '"Satoshi", system-ui, sans-serif';
const FALLBACK_AVG_CHAR_RATIO = 0.5; // Satoshi lowercase avg ≈ 0.50 of em
const FONT_WEIGHT = 700; // .btn and .bid-value are font-weight: 700

const ctx =
  typeof document !== "undefined"
    ? document.createElement("canvas").getContext("2d")
    : null;

/**
 * Measure rendered width of `string` at `fontPx` in the project font.
 *
 * In a non-DOM context (e.g. Vitest node tests), returns a documented
 * heuristic fallback. Real production callers always run in a browser.
 */
export function measureText(string, fontPx) {
  if (!ctx) return string.length * fontPx * FALLBACK_AVG_CHAR_RATIO;
  ctx.font = `${FONT_WEIGHT} ${fontPx}px ${FONT_FAMILY}`;
  return ctx.measureText(string).width;
}
